<template>
  <avtalat-modal :idealWidth="500" :idealHeight="300"
    ><div>
      <div>
        Personen saknar e-postadress. Om du sparar detta ärende kommer du skicka
        ett säkert meddelande till kunden utan att kunden får en notifiering om
        att det finns ett nytt säkert meddelande.
      </div>
      <div class="mt-sm flex justify-evenly">
        <avtalat-button outlined @click="() => emit('cancel')"
          >Avbryt</avtalat-button
        >
        <avtalat-button @click="() => emit('submit')"
          >Spara ändå</avtalat-button
        >
      </div>
    </div></avtalat-modal
  >
</template>

<script setup lang="ts">
const emit = defineEmits(["submit", "cancel"]);
</script>
